import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=dccfa4c8&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.css?vue&type=style&index=0&id=dccfa4c8&prod&scoped=true&lang=css&"
import style1 from "./RegistrationFormUnScoped.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccfa4c8",
  null
  
)

export default component.exports